import uuid from 'uuid/v1';

const generateId = () => uuid().replaceAll('-', '');

export default generateId;
